// The `reason` values the login endpoints answer with (cognito/cognito_auth.py),
// mapped to the i18n text shown for each. The server never words these itself.
const REASON_MESSAGES = {
  invalid_credentials: 'auth.invalidCredentials',
  user_not_confirmed: 'auth.userNotConfirmed',
  invitation_expired: 'auth.invitationExpired',
  invalid_code: 'auth.invalidCode',
  code_expired: 'auth.codeExpired',
  challenge_expired: 'auth.challengeExpired',
  too_many_attempts: 'auth.tooManyAttempts',
  service_unavailable: 'auth.serviceUnavailable',
  invalid_request: 'auth.invalidRequest',
  email_not_verified: 'auth.emailNotVerified',
  unsupported_challenge: 'auth.unsupportedChallenge',
  role_not_allowed: 'auth.roleNotAllowed',
  unknown_provider: 'auth.redirectFailed',
  cognito_misconfigured: 'auth.redirectFailed',
}

export const reasonMessage = (intl, res) => {
  // Cognito's password policy is the one message passed through, because the
  // user has to read the rule they broke.
  if (res?.reason === 'password_policy') {
    return `${intl.formatMessage({ id: 'auth.passwordPolicy' })} ${res?.msg || ''}`.trim()
  }
  return intl.formatMessage({
    id: REASON_MESSAGES[res?.reason] || 'auth.loginFailed',
  })
}

// Only a same-origin path may follow sign-in, never another site.
export const safeNextPath = (next) =>
  next && next.startsWith('/') && !next.startsWith('//') && !next.includes('\\')
    ? next
    : '/vehicles'
